module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.activities
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "title",
      "label": "标题"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "startDate",
      "label": "日期",
      "width": "75",
      "formatter": _vm.dateFormatter
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "viewer",
      "label": "浏览量",
      "width": "75"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-934def9a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/activity/LatestActivity.vue
// module id = 1186
// module chunks = 2